export interface Post {
  slug: string
  title: string
  date: string
  readTime: string
  excerpt: string
  tags: string[]
  featured?: boolean
}

export const posts: Post[] = [
  {
    slug: 'making-ai-useful-inside-bank',
    title: 'Making AI useful inside a bank',
    date: 'Oct 2023',
    readTime: '8 min read',
    excerpt:
      'Moving beyond the hype to practical, regulated implementation of LLMs in financial workflows. How we built a secure gateway and internal chat interface.',
    tags: ['AI', 'FinTech', 'Engineering'],
    featured: true,
  },
  {
    slug: 'measuring-engineering-success',
    title: 'Measuring engineering success beyond delivery',
    date: 'Aug 2023',
    readTime: '6 min read',
    excerpt:
      'Why velocity metrics fail and how to measure actual business impact and team health using DORA and SPACE frameworks.',
    tags: ['Leadership', 'Metrics'],
  },
  {
    slug: 'why-internal-platforms-fail',
    title: 'Why internal platforms fail',
    date: 'May 2023',
    readTime: '5 min read',
    excerpt:
      'Common pitfalls in building IDPs and how to treat your platform as a product with internal customers.',
    tags: ['Platform', 'DevOps'],
  },
  {
    slug: 'hiring-senior-engineers',
    title: 'Hiring senior engineers and leads',
    date: 'Feb 2023',
    readTime: '7 min read',
    excerpt:
      'A framework for identifying high-leverage individuals who raise the bar for the whole team, beyond just coding skills.',
    tags: ['Hiring', 'Leadership'],
  },
]
